enum Permissions {
  DISPLAY_DASHBOARD = 'display-dashboard',
  DISPLAY_SOCIAL_LINK_FORM = 'display-social-link-form',
  LIST_ADMIN_USERS = 'list-admin-users',
  CREATE_ADMIN_USERS = 'create-admin-users',
  UPDATE_ADMIN_USERS = 'update-admin-users',
  DELETE_ADMIN_USERS = 'delete-admin-users',
  LIST_ACCOUNTS = 'list-accounts',
  UPDATE_ACCOUNTS = 'update-accounts',
  DELETE_ACCOUNTS = 'delete-accounts',
  CREATE_ACCOUNTS = 'create-accounts',
  UPDATE_FACEBOOK_CREDENTIALS = 'update-facebook-credentials',
  SELF_ACCOUNTS = 'self-accounts',
  SELF_ALLIANCES = 'self-alliances',
  LIST_COUNTRIES = 'list-countries',
  UPDATE_COUNTRIES = 'update-countries',
  LIST_SITES = 'list-sites',
  LIST_IMPORTERS = 'list-importers',
  LIST_PLANS = 'list-plans',

  LIST_VEHICLES = 'list-vehicles',
  LIST_ALLIANCES = 'list-alliances',
  LIST_EXPIRED = 'list-expired',
  STORE_VEHICLES = 'store-vehicles',
  UPDATE_VEHICLES = 'update-vehicles',
  DELETE_VEHICLES = 'delete-vehicles',
  SHOW_VEHICLES = 'show-vehicles',
  EXPIRE_VEHICLES = 'expire-vehicles',
  ACCOUNT_VEHICLES = 'account-vehicles',
  SEARCH_VIN = 'search_vin',
  REFRESH_VEHICLES = 'refresh_vehicles',
  ADD_VEHICLES_IMAGES = 'add-vehicles-images',
  DELETE_VEHICLES_MEDIA = 'delete-vehicles-media',
  LIST_APP_USERS = 'list-app-users',
  CREATE_APP_USERS = 'create-app-users',
  SHOW_APP_USER = 'show-app-user',
  UPDATE_APP_USER = 'update-app-user',
  DELETE_APP_USER = 'delete-app-user',
  RETRIVE_FACEBOOK_PAGES = 'retrive-facebook-pages',
  SHARE_VEHICLES = 'share-vehicles',
  GET_SHARE_URL = 'get-share-url',

  // WebApp permissions
  ACCESS_SCREEN_ACCOUNT = 'access-screen-account',
  ACCESS_SCREEN_API_KEYS = 'access-screen-api-keys',
  ACCESS_DEALS_SCREEN = 'access-deals-screen',
}

export default Permissions;
